import React, { useState, useEffect, useRef, useContext } from 'react'
import classNames from 'classnames'
import { Spacer, Field, Button, Label, Divider, Checkbox, Card, Icon, Row, Col, Collapse } from '@cleartrip/bento'
import Modal from 'lib/Modal'
import ModalHeader from './UserProfileModalHeader'
import Dropdown from 'components/Dropdown'
import {
    validateEmail,
    validateMobileNumber,
    validatePassword,
    onlyNumbersRegex,
    validateLastName,
    validateFirstName
} from 'utils/flights/itinerary'
import USER_PROFILE_PAGE_CONTANTS from './UserProfileConstants'
import langTranslate from 'locale'
import { userSignIn, userResetPassword, userSignUp, getUserByEmailId, getAbTestConfig } from 'api/flights/results'
import { dataLayerGA } from 'utils/dataLayerHelper.js'
import { getCookie, isEmpty, isUserSignedIn } from 'utils/browserHelper'
import { ResultsDataContext, ProfileDataContext } from 'context/flights/results'
import { UserProfileContext } from 'context/itinerary'
import { ItineraryDataContext } from 'context/itinerary'

import { sendClevertapUIActionEvent as ClevertapEvent } from 'utils/globalNav/unifiedLogin'

import { formSrpSearchQuery } from 'utils/flights/results'
import { resolveKeysInObjectsArrays } from 'utils/browserHelper'

import RegisteredUserBlock from './screens/SignedInUserBlock'

import SignUpForm from './screens/SignUpForm'
import EmailsLinked from './screens/EmailsLinked'
import VerifyEmail from './screens/VerifyEmail'
import LinkAccounts from './screens/LinkAccounts'
import VerifyMobileInputField from './screens/VerifyMobileField'
import ResetPassword from './screens/ResetPassword'
import CheckYourEmail from './screens/CheckYourEmail'
import LinkAccountsSuccess from './screens/AccountsLinkSuccess'
import Loader from './screens/Loader/Loader'
import PersonalDetails from './screens/PersonalDetails'
import EmailLinkedPersonalDetails from './screens/VerifiedEmailPersonalDetails'
import { fetchUserProfileData } from 'api/flights/itinerary'
import LoginWithMobileNew from './screens/loginWithMobileNew'
import SignInBlockNew from './screens/SignNew'
import VerifyMobileNumberNew from './screens/VerifyMobileNumberNew'

const isRtl = process.env.CONTENT_DIR === 'RTL'
function ViewContainer({
    isShowing,
    toggle,
    page,
    handleIsShowing,
    showCloseButton = true,
    redirectUrl = '',
    disableEmailLogin = false,
    setLoginCase,
    hideLoginBanner=false,
    superCoinAddNumber = false,
    superCoinLogin = false,
    abLogin = 'a',
    abInline = 'a'
}) {
    const [userProfile, setUserProfile] = useContext(ProfileDataContext)
    const MOBILE_COUNTRY_CODES = { IN: { name: 'India', code: '91', min: 10, max: 10 } }
    const [initialRender,setInitialRender] = useState(true)
    const countryCode = 'IN'
    // DOMAIN_COUNTRY_MAP[DOMAIN] || 'IN'

    const defaultCode = MOBILE_COUNTRY_CODES[countryCode]['code'] || ''
    const defaultMinLength = MOBILE_COUNTRY_CODES[countryCode]['min'] || ''
    const defaultMaxLength = MOBILE_COUNTRY_CODES[countryCode]['max'] || ''
    const [userData, setUserData] = useContext(UserProfileContext)

    const [pageName, setPageName] = useState(page)
    const [showPasswordRules, setShowPasswordRules] = useState(false)
    const animationDefaultState = { isAnimate: false, direction: 'right', isFadeIn: false }
    const [animationParams, setAnimationParams] = useState(animationDefaultState)
    // const [isAnimate, setIsAnimate] = useState(false)
    const [showGSTIN, setShowGSTIN] = useState(false)
    const [rememberCheckedStatus, setRememberCheckedStatus] = useState(true)
    const [travelCheckedStatus, setTravelCheckedStatus] = useState(false)
    const [signInError, setSignInError] = useState(false)
    const [isSignInButtonLoading, setSignInButtonLoading] = useState(false)
    const [userSignedIn, setUserSignedIn] = useState(false)
    let [email, setEmail] = useState(userData?.customer?.email ||  userProfile?.username || '')
    let [isEmailValid, setEmailValid] = useState(true)
    let [firstName, setFirstName] = useState('')
    let [isValidFirstName, setFirstNameValid] = useState(true)
    const [accountExists, setAccountExists] = useState(false)
    let [lastName, setLastName] = useState('')
    let [isValidLastName, setLastNameValid] = useState(true)
    const [gstin, setGstin] = useState('')
    let [isGSTValid, setGSTValid] = useState(true)
    const [companyName, setCompanyName] = useState('')
    let [isCompanyValid, setCompanyValid] = useState(true)
    let [password, setPassword] = useState('')
    let [confirmPassword, setConfirmPassword] = useState('')
    let [isPasswordValid, setPasswordValid] = useState(true)
    let [isConfirmPasswordValid, setConfirmPasswordValid] = useState(true)
    const [defaultCountryCode, setDefaultCountryCode] = useState(isRtl ? defaultCode + '+' : '+' + defaultCode)
    const [defaultCountryCodeMinLen, setDefaultCountryCodeMinLen] = useState(defaultMinLength)
    const [defaultCountryCodeMaxLen, setDefaultCountryCodeMaxLen] = useState(defaultMaxLength)
    let [isMobileValid, setMobileValid] = useState(true)
    let [passwordType, setPasswordType] = useState(true)
    let [confirmPasswordType, setConfirmPasswordType] = useState(true)
    let [signInPasswordType, setSignInPasswordType] = useState(true)
    const [toggleGender, setToggleGender] = useState(false)
    const [gender, setGender] = useState('')
    const [genderError, setGenderError] = useState(false)
    let [mobileNumber, setMobileNumber] = useState('')
    const [toggleDropdown, setToggleDropdown] = useState(false)
    const [signUpFormError, setSignUpFormError] = useState(false)
    const [showEmailNotFound, setShowEmailNotFound] = useState(false)
    const [linkedEmails, setLinkedEmails] = useState([])

    const [resultsData] = useContext(ResultsDataContext)

    const [itineraryData] = useContext(ItineraryDataContext)
    const errorRef = useRef(null)

    const gstinRegex = new RegExp('^((0[1-9])|([1-2][0-9])|(3[0-7]))[A-Za-z]{5}[0-9]{4}[A-Za-z]{1}[A-Za-z0-9]{3}?$')
    const oneSpecialCharacterRegex = /[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/
    const lowerCaseRegex = /[a-z]/
    const uperCaseRegex = /[A-Z]/
    const numberRegex = /[0-9]/
    const animatedClass = classNames({
        'slide-in-right': animationParams.direction === 'right' && animationParams.isAnimate,
        'slide-in-left': animationParams.direction === 'left' && animationParams.isAnimate,
        'px-8': 'px-8'
    })
    const query = resolveKeysInObjectsArrays(['location', 'pathname'], window)
    const pathname = query.split('/')
    const pagePath = pathname[2]

    useEffect(() => {
        if (!isShowing) {
            setPageName(null)
            setShowPasswordRules(false)
            setShowGSTIN(false)
        } else setPageName(page)
    }, [page, isShowing])




    useEffect(() => {
        if (pageName === 'MOBILESIGNINUP' || pageName === 'RESET') {
            setToDefault()
        } else if (pageName === 'EMAIL_MOBILE_LINKED') {
            setMobileValid(true)
            setMobileNumber('')
            setToggleDropdown(false)
        }
    }, [pageName])
    useEffect(() => {
        if (userData?.customer?.email) {
            setEmail(userData.customer.email)
        } else if(userProfile?.username) {
            setEmail(userProfile.username)
        }
    }, [userData, userProfile])

    const getSearchUrlParams = () => {
        const searchUrl = location.search || ''
        let params = searchUrl
        if (searchUrl.indexOf('?') > -1) {
            params = searchUrl.slice(1)
        }

        const urlParam = formSrpSearchQuery(params)
        return urlParam
    }

    let urlParam = ''

    if (pagePath === 'results') {
        urlParam = getSearchUrlParams()
    }

    const checkHiFiveFlow = () => {
        const retVal =
            pathname &&
            pathname.length > 2 &&
            pathname[1] === 'ref' &&
            !isEmpty(pathname[2]) &&
            pathname[2] != 'null' &&
            pathname[2] != 'undefined'
        return retVal
    }

    const isHiFiveFlow = checkHiFiveFlow()

    function goBackAnimation(page) {
        setAnimationParams({
            isAnimate: true,
            direction: 'left'
        })
        setTimeout(() => {
            clickHandler(page, false)
        }, 200)
    }

    function clickHandler(page, isAnimate) {
        setAnimationParams({ isAnimate: isAnimate, direction: isRtl ? 'left' : 'right' })

        setPageName(page)
        setTimeout(() => {
            setAnimationParams(animationDefaultState)
        }, 300)
    }

    const executeScroll = () => errorRef.current.scrollIntoView()
    const resendResetPassword = async () => {
        const resetPwdResponse = await userResetPassword(email)

        const { status: resetPwdStatus } = resetPwdResponse || {}

        if (resetPwdStatus == 202) {
            return true
        } else {
            return false
        }
    }
    const resetPassword = async (page, isAnimate, email) => {
        const validateEmail = validateEmailHandler()
        if (!validateEmail) {
            ClevertapEvent({
                actionName: 'Invalid_value_entered',
                actionType: 'Button',
                page:
                    pagePath === 'results'
                        ? 'SRP'
                        : isEmpty(pagePath) || isHiFiveFlow
                        ? 'HP'
                        : pathname.length > 4 && pathname[4] === 'info' && pathname[2] === 'itinerary'
                        ? 'Itinerary'
                        : 'Confirmation_Page',

                currentPage: pagePath,
                field_name: 'email',
                form_name: 'ResetPassword'
            })
            setEmailValid(validateEmail)
        } else {
            const resetPwdResponse = await userResetPassword(email)

            const { status: resetPwdStatus } = resetPwdResponse || {}

            if (resetPwdStatus == 202) {
                setAnimationParams({ isAnimate: isAnimate, direction: 'right' })

                setPageName(page)
                setTimeout(() => {
                    setAnimationParams(animationDefaultState)
                }, 300)
            } else {
                setShowEmailNotFound(true)
                setEmailValid(false)
            }
        }
    }

    const setToDefault = () => {
        setMobileValid(true)
        setEmailValid(true)
        setPasswordValid(true)
        setConfirmPasswordValid(true)
        setShowEmailNotFound(false)
        setSignInError(false)
        setShowGSTIN(false)
        setEmail('')
        setFirstName('')
        setFirstNameValid(true)
        setLastName('')
        setLastNameValid(true)
        setGSTValid(true)
        setGstin('')
        setCompanyName('')
        setCompanyValid(true)
        setPassword('')
        setConfirmPassword('')
        setPasswordType(true)
        setConfirmPasswordType(true)
        setSignInPasswordType(true)
        setToggleGender(false)
        setGender('')
        setMobileNumber('')
        setToggleDropdown(false)
        setSignUpFormError(false)
        setGenderError(false)
        setAccountExists(false)
        //can add more default states if needed
    }

    const renderPage = () => {
        switch (pageName) {
            case USER_PROFILE_PAGE_CONTANTS.SIGNIN_PAGE:
                return MobileSignInUpBlock
            case USER_PROFILE_PAGE_CONTANTS.RESET_PAGE:
                return ResetBlock
            case USER_PROFILE_PAGE_CONTANTS.SIGNUP_PAGE:
                return MobileSignInUpBlock
            case USER_PROFILE_PAGE_CONTANTS.RESET_CONFIRMATION_PAGE:
                return ResetConfirmationBlock
            case USER_PROFILE_PAGE_CONTANTS.SIGNEDIN_USER_PAGE:
                return SignedInUserBlock
            case USER_PROFILE_PAGE_CONTANTS.SIGNUP_FORM_PAGE:
                return SignUpFormBlock
            case USER_PROFILE_PAGE_CONTANTS.VERIFY_MOBILE_NUMBER:
                return VerifyNumberBlock
            case USER_PROFILE_PAGE_CONTANTS.EMAIL_LINKED:
                return EmailLinked
            case USER_PROFILE_PAGE_CONTANTS.VERIFY_EMAIL:
                return VerifyEmailBlock
            case USER_PROFILE_PAGE_CONTANTS.LINK_ACCOUNTS:
                return LinkAccountsBlock
            case USER_PROFILE_PAGE_CONTANTS.SIGNIN_EMAIL:
                return SigninBlock
            case USER_PROFILE_PAGE_CONTANTS.EMAIL_MOBILE_LINKED:
                return VerifyMobileInputFieldBlock
            case USER_PROFILE_PAGE_CONTANTS.LINK_SUCCESS:
                return LinkAccountsSuccessBlock
            case USER_PROFILE_PAGE_CONTANTS.LOADER:
                return LoaderBlock
            case USER_PROFILE_PAGE_CONTANTS.PERSONAL_DETAILS:
                return PersonalDetailsBlock
            case USER_PROFILE_PAGE_CONTANTS.EMAIL_LINKED_PERSONAL_DETAILS:
                return EmailLinkedPersonalDetailsBlock
            default:
                return null
        }
    }

    const handleLinkClick = url => {
        let dest = `${window.location.origin}/${url}`
        window.open(dest, '_blank')
    }
    const changeEmailHandler = e => {
        setEmailValid(true)
        setShowEmailNotFound(false)
        setEmail(e.target.value)
    }
    const validateEmailHandler = e => {
        const temp = validateEmail(email)
        setEmailValid(temp)
        return temp
    }
    const changeCompanyHandler = e => {
        let companyValid = true
        setCompanyName(e.currentTarget.value)
        companyValid = !isEmpty(companyName)
        setCompanyValid(companyValid)
    }
    const changeGstinHandler = e => {
        const gstin = e.currentTarget.value
        if (gstin.length <= 15) {
            setGstin(gstin.toUpperCase())
        }
        setGSTValid(true)
    }
    const changeFirstNameHandler = e => {
        setFirstNameValid(true)
        setFirstName(e.target.value)
    }
    const changeLastNameHandler = e => {
        setLastNameValid(true)
        setLastName(e.target.value)
    }
    const validateFirstNameHandler = e => {
        const temp = validateFirstName(firstName, 32)

        setFirstNameValid(temp)
        return temp
    }
    const validateLastNameHandler = e => {
        const temp = validateLastName(lastName, 1, 32)
        setLastNameValid(temp)
        return temp
    }
    const changePasswordHandler = e => {
        setPasswordValid(true)
        setPassword(e.target.value)
    }
    const changeConfirmPasswordHandler = e => {
        setConfirmPasswordValid(true)
        setConfirmPassword(e.target.value)
    }

    const validatePasswordHandler = e => {
        const temp = validatePassword(password)
        setPasswordValid(temp)
        return temp
    }
    const validateConfirmPasswordHandler = e => {
        const temp = confirmPassword === password ? true : false
        setConfirmPasswordValid(temp)
        return temp
    }

    const validateMobileHandler = e => {
        const isMobileValid = validateMobileNumber(mobileNumber, defaultCountryCodeMinLen, defaultCountryCodeMaxLen)
        setMobileValid(isMobileValid)
        if (isMobileValid) {
            dataLayerGA({ section: 'Login' }, 'login_mobile_no_filled')
        }
        return isMobileValid
    }
    const changeMobileHandler = e => {
        const mobile = e.target.value
        if (!isEmpty(mobile) && !onlyNumbersRegex.test(mobile)) {
            return
        }
        if (mobile.length <= defaultCountryCodeMaxLen) {
            setMobileValid(true)
            setMobileNumber(mobile)
        }
    }
    const countryCodeHandler = (code, min, max) => {
        if (isRtl) setDefaultCountryCode(code + '+')
        else setDefaultCountryCode('+' + code)
        setDefaultCountryCodeMinLen(min)
        setDefaultCountryCodeMaxLen(max)
        setToggleDropdown(toggleDropdown === code ? true : code)
        setMobileValid(true)
    }
    const mobileCountryCodesItem = codeObj => {
        const { name, code, min, max } = codeObj
        return (
            <Dropdown.Item
                selected={'+' + code === defaultCountryCode}
                className="fs-3  hover:bg-secondary-500 c-pointer hover:c-white"
                onClick={() => countryCodeHandler(code, min, max)}
            >
                {name} (+{code})
            </Dropdown.Item>
        )
    }
    const populateMobileCountryCode = () => {
        const mobileCountryCodes = []
        // for (let popularCountry of POPULAR_MOBILE_COUNTRY) {
        //     const codeObj = MOBILE_COUNTRY_CODES[popularCountry]
        //     mobileCountryCodes.push(mobileCountryCodesItem(codeObj))
        // }
        for (let countryCode in MOBILE_COUNTRY_CODES) {
            const codeObj = MOBILE_COUNTRY_CODES[countryCode]
            mobileCountryCodes.push(mobileCountryCodesItem(codeObj))
        }
        return mobileCountryCodes
    }
    const selectGender = e => {
        const arabicGenderMapping = {
            [langTranslate('Male')]: 'Male',
            [langTranslate('Female')]: 'Female'
        }
        const selectedGender = arabicGenderMapping[e.currentTarget.innerText] || ''

        // onChangeHandler(traveller, 'gender', selectedGender)
        setGender(selectedGender)
        setToggleGender(toggleGender === selectedGender ? true : selectedGender)
        setGenderError(false)
    }

    const toggleModalAndClosePage = (isRefresh = true) => {
        setTimeout(() => {
            toggle()
        }, 300)
        if (!isEmpty(redirectUrl) && isUserSignedIn()) {
            window.location.href = redirectUrl
        } else if (isRefresh) {
            setTimeout(() => {
                window.location.reload()
            }, 400)
        }
    }
    const dismissalPage = () => {
        switch (pageName) {
            case USER_PROFILE_PAGE_CONTANTS.SIGNIN_PAGE:
                return 'Entering_mobile_number'
            case USER_PROFILE_PAGE_CONTANTS.RESET_PAGE:
                return 'Enter_email_for_reset'
            case USER_PROFILE_PAGE_CONTANTS.SIGNUP_PAGE:
                return 'Entering_mobile_number'
            case USER_PROFILE_PAGE_CONTANTS.RESET_CONFIRMATION_PAGE:
                return 'Reset_password_link_sent'
            case USER_PROFILE_PAGE_CONTANTS.SIGNEDIN_USER_PAGE:
                return ''
            case USER_PROFILE_PAGE_CONTANTS.SIGNUP_FORM_PAGE:
                return ''
            case USER_PROFILE_PAGE_CONTANTS.VERIFY_MOBILE_NUMBER:
                return 'Entering_OTP'
            case USER_PROFILE_PAGE_CONTANTS.EMAIL_LINKED:
                return 'Selecting_linked_emails'
            case USER_PROFILE_PAGE_CONTANTS.VERIFY_EMAIL:
                return 'Entering_OTP'
            case USER_PROFILE_PAGE_CONTANTS.LINK_ACCOUNTS:
                return 'Linking_accounts'
            case USER_PROFILE_PAGE_CONTANTS.SIGNIN_EMAIL:
                return 'Email_login'
            case USER_PROFILE_PAGE_CONTANTS.EMAIL_MOBILE_LINKED:
                return 'Enterig_mobile_number_after_email_sign_in'
            case USER_PROFILE_PAGE_CONTANTS.LINK_SUCCESS:
                return ''
            case USER_PROFILE_PAGE_CONTANTS.LOADER:
                return ''
            case USER_PROFILE_PAGE_CONTANTS.PERSONAL_DETAILS:
                return 'Enter_personal_details'
            case USER_PROFILE_PAGE_CONTANTS.EMAIL_LINKED_PERSONAL_DETAILS:
                return 'Email_linked_personal_details'
            default:
                return ''
        }
    }
    function handleSignInToggle() {
        setMobileNumber('')
        let dismissalPoint = dismissalPage()
        let popupDismiss = false
        const obj = JSON.parse(window.sessionStorage.getItem('loginPopup'))

        if (pagePath === 'itinerary' && obj?.flightIternary) {
            popupDismiss = true
        } else if (pagePath === undefined && obj?.flightHome) {
            popupDismiss = true
        }

        ClevertapEvent({
            actionName: 'Login_modal_dismissed',
            actionType: 'Button',
            auto_pop: popupDismiss,
            page:
                pagePath === 'results'
                    ? 'SRP'
                    : isEmpty(pagePath) || isHiFiveFlow
                    ? 'HP'
                    : pathname.length > 4 && pathname[4] === 'info' && pathname[2] === 'itinerary'
                    ? 'Itinerary'
                    : 'Confirmation_Page',

            currentPage: pagePath,
            point_of_dismissal: dismissalPoint
        })
        dataLayerGA({ section: 'Login' }, 'login_skip_clicked')
        if (userSignedIn) {
            if (isHiFiveFlow) {
                toggleModalAndClosePage(false)
            } else {
                toggleModalAndClosePage()
            }
        } else {
            setInitialRender(true)
            toggle()
        }
    }
    let spanClass = 'fs-2 c-secondary-500 c-pointer hover:td-underline p-absolute h-9 flex flex-middle r-2 fw-500 t-0'
    if (isRtl) {
        spanClass = 'fs-2 c-secondary-500 c-pointer hover:td-underline p-absolute h-9 flex flex-middle l-2 fw-500 t-0'
    }
    let checkboxClass = 'nl-1'
    if (isRtl) {
        checkboxClass = ''
    }
    let checkBoxTextClass = 'pl-1 c-neutral-700  fs-2 nl-1'
    if (isRtl) {
        checkBoxTextClass = 'pr-2 c-neutral-700  fs-2 '
    }

    let errorInfo = 'fs-inherit c-inherit pl-2'
    if (isRtl) {
        errorInfo = 'fs-inherit c-inherit pr-2'
    }

    const mobileAndCountryCodeItem = isRtl ? (
        <Row>
            <Col>
                <Field
                    type="text"
                    placeholder={langTranslate('Enter mobile number')}
                    onChange={changeMobileHandler}
                    onBlur={validateMobileHandler}
                    hasError={!isMobileValid}
                    value={mobileNumber}
                    style={{ direction: 'ltr' }}
                />
                {!isMobileValid &&
                    (mobileNumber.length === 0 ? (
                        <div className="c-error-500 fs-2 mt-1">{langTranslate('Please enter a phone number')}</div>
                    ) : (
                        <div className="c-error-500 fs-2 mt-1">
                            {langTranslate('Please enter a valid phone number')}
                        </div>
                    ))}
            </Col>
            <Col span="7">
                <Dropdown overlay={false} toggle={toggleDropdown}>
                    <Dropdown.Select className="h-9 p-0 px-2 fs-3" width={80} label={defaultCountryCode} />
                    <Dropdown.Menu width={300} className="oy-auto" style={{ maxHeight: '198px' }}>
                        {populateMobileCountryCode()}
                    </Dropdown.Menu>
                </Dropdown>
            </Col>
        </Row>
    ) : (
        <Row>
            <Col span="6">
                <Dropdown overlay={false} toggle={toggleDropdown}>
                    <Dropdown.Select
                        hasError={!isMobileValid && defaultCountryCodeMaxLen < mobileNumber.length}
                        className="h-9 p-0 px-2 fs-3"
                        width={80}
                        label={defaultCountryCode}
                    />
                    <Dropdown.Menu width={196} className="oy-auto" style={{ maxHeight: '198px' }}>
                        {populateMobileCountryCode()}
                    </Dropdown.Menu>
                </Dropdown>
            </Col>
            <Col>
                <Field
                    data-testid="Mobile"
                    type="text"
                    placeholder={langTranslate('Enter mobile number')}
                    onChange={changeMobileHandler}
                    onBlur={validateMobileHandler}
                    hasError={!isMobileValid}
                    value={mobileNumber}
                />
                {!isMobileValid &&
                    (mobileNumber.length === 0 ? (
                        <div className="c-error-500 fs-2 mt-1">{langTranslate('Please enter a phone number')}</div>
                    ) : (
                        defaultCountryCodeMaxLen >= mobileNumber.length && (
                            <div data-testid="invalidMobileMessage" className="c-error-500 fs-2 mt-1">
                                {langTranslate('Please enter a valid phone number')}
                            </div>
                        )
                    ))}
            </Col>
            {!isMobileValid && defaultCountryCodeMaxLen < mobileNumber.length && (
                <div data-testid="invalidMobileMessage" className="ml-2 c-error-500 fs-2 mt-1">
                    {langTranslate('Please check your country code and phone number.')}
                </div>
            )}
        </Row>
    )

    async function redirectToPage() {
        //TODO add api call
        if (isEmpty(email)) {
            setPageName(USER_PROFILE_PAGE_CONTANTS.EMAIL_LINKED)
        } else {
            setPageName(USER_PROFILE_PAGE_CONTANTS.LINK_ACCOUNTS)
        }
    }

    const signUpCreate = async () => {
        let signUpError = false
        if (isEmpty(password)) {
            setPasswordValid(false)
            signUpError = true
        } else if (
            !uperCaseRegex.test(password) ||
            !numberRegex.test(password) ||
            !lowerCaseRegex.test(password) ||
            !oneSpecialCharacterRegex.test(password) ||
            password.length < 8
        ) {
            setPasswordValid(false)
            signUpError = true
        }
        if (isEmpty(confirmPassword)) {
            setConfirmPasswordValid(false)
            signUpError = true
        }
        if (isEmpty(firstName)) {
            setFirstNameValid(false)
            signUpError = true
        }
        if (isEmpty(lastName)) {
            setLastNameValid(false)
            signUpError = true
        }
        if (!isConfirmPasswordValid) {
            signUpError = true
        }
        if (!isValidFirstName) {
            signUpError = true
        }
        if (!isValidLastName) {
            signUpError = true
        }
        if (isEmpty(gender)) {
            setGenderError(true)
            signUpError = true
        }
        if (!validateMobileHandler()) {
            setMobileValid(false)
            signUpError = true
        }
        if (showGSTIN) {
            if (isEmpty(companyName)) {
                setCompanyValid(false)
                signUpError = true
            }
            if (isEmpty(gstin)) {
                setGSTValid(false)
                signUpError = true
            } else if (!gstinRegex.test(gstin)) {
                setGSTValid(false)
                signUpError = true
            }
        }

        if (signUpError) {
            setSignUpFormError(true)
            setTimeout(() => {
                executeScroll()
            }, 200)
        } else {
            // ClevertapEvent({
            //     actionName: 'create_account',
            //     actionType: 'Button',
            //     page: 'flights_sign_up',
            //     urlParam,
            //     resultsData,
            //     itineraryData,
            //     currentPage: pagePath
            // })
            setSignUpFormError(false)
            let countryCode = defaultCountryCode.substring(1)
            let payload = {
                username: email,
                gstDetails: [
                    {
                        id: '',
                        gstHolderAddress: null,
                        gstHolderName: '',
                        gstHolderStateCode: null,
                        gstHolderStateName: null,
                        gstNumber: gstin
                    }
                ],
                companyDetails: [
                    {
                        companyName: companyName,
                        domain: window.location.domain,
                        status: '1'
                    }
                ],
                travellerDetails: [
                    {
                        isRegistered: true,
                        profileData: null,
                        contactInfo: {
                            phoneNumbers: [
                                {
                                    mobileNumber: mobileNumber,
                                    mobileCountryCode: countryCode,
                                    category: 'mobile'
                                }
                            ],
                            whatsapp: null,
                            addresses: [],
                            otherDetails: [],
                            emails: []
                        },
                        ffnPreferences: null,
                        personalDetails: {
                            anniversaryDate: null,
                            companyDesignation: null,
                            concatName: `${firstName}${lastName}${email}`,
                            countryOfResidence: null,
                            countryOfResidenceId: null,
                            countryPreference: null,
                            currency: null,
                            dateOfBirth: null,
                            department: null,
                            emergencyContactName: null,
                            emergencyContactNumber: null,
                            firstName: `${firstName}`,
                            gender: `${gender}`,
                            homeAirport: null,
                            homeAirportId: null,
                            language: null,
                            lastName: `${lastName}`,
                            middleName: null,
                            nickName: null,
                            primaryEmail: null,
                            title: ''
                        },
                        preferences: null,
                        docDetails: null
                    }
                ],
                password: password
            }

            const apiResponse = await userSignUp(payload)
            const { status, error } = apiResponse
            if (error && error.response && error.response.status === 403) {
                setAccountExists(true)
            } else if (status === 202) {
                const payload = {
                    username: email,
                    password: password
                }

                const apiResponse = await userSignIn(payload)
                setTimeout(() => {
                    handleIsShowing()
                }, 300)
                setTimeout(() => {
                    window.location.reload()
                }, 400)
            } else {
                setSignUpFormError(true)
            }
        }
    }

    const getUserProfileData = async () => {
        try {
            const { itineraryId } = itineraryData
            let UserProfileResponse = await fetchUserProfileData(itineraryId)
            setUserData(UserProfileResponse.data)
        } catch (e) {
            logError(e)
            console.log('User Profile api error', e)
        }
    }

    const onContinue = async () => {
        // Reset Error
        setSignInButtonLoading(true)
        setSignInError('')
        const emailValidation = validateEmailHandler()
        setEmailValid(emailValidation)
        if (emailValidation && isEmailValid && email) {
            const isValidPassword = validatePasswordHandler()
            if (!isValidPassword) {
                ClevertapEvent({
                    actionName: 'Invalid_value_entered',
                    actionType: 'Button',
                    page:
                        pagePath === 'results'
                            ? 'SRP'
                            : isEmpty(pagePath) || isHiFiveFlow
                            ? 'HP'
                            : pathname.length > 4 && pathname[4] === 'info' && pathname[2] === 'itinerary'
                            ? 'Itinerary'
                            : 'Confirmation_Page',

                    currentPage: pagePath,
                    field_name: 'password',
                    form_name: 'EmailLogin'
                })
                setSignInButtonLoading(false)
                return false
            }
            // User Login
            // ClevertapEvent({
            //     actionName: 'sign_in_clicked',
            //     actionType: 'Button',
            //     page: 'flights_sign_in',
            //     urlParam,
            //     resultsData,
            //     itineraryData,
            //     currentPage: pagePath
            // })

            const payload = {
                username: email,
                password: password
            }

            const apiResponse = await userSignIn(payload)
            const { data, status } = apiResponse
            const { status: dataStatus } = data || {}
            if (status !== 200 || dataStatus === 'INTERNAL_SERVER_ERROR') {
                const { error: { response: { data: { message = '' } = {} } = {} } = {} } = apiResponse
                if (
                    apiResponse?.error?.response?.status === 410 &&
                    apiResponse?.error?.response?.data?.message === 'AUTHENTICATION_ERROR'
                ) {
                    setSignInError(langTranslate('Password doesn’t exist or has expired.'))
                    setPasswordValid(false)
                } else if (message.includes(langTranslate('username and password do not match'))) {
                    setSignInError(langTranslate('Entered email and password does not match.'))

                    setPasswordValid(false)
                } else if (message.includes('no user found')) {
                    setSignInError(langTranslate('Entered email is not found'))
                    setEmailValid(false)
                    setPasswordValid(false)
                } else {
                    setSignInError(langTranslate('Something went wrong. Please try again.'))
                }
                setSignInButtonLoading(false)
                return false
            } else if (status == 200) {
                dataLayerGA({ method: 'email', section: 'Login' }, 'sign_in_button_clicked')
                let popupLogin = false
                const obj = JSON.parse(window.sessionStorage.getItem('loginPopup'))

                if (pagePath === 'itinerary' && obj?.flightIternary) {
                    popupLogin = true
                } else if (pagePath === undefined && obj?.flightHome) {
                    popupLogin = true
                }

                ClevertapEvent({
                    actionName: 'Login_succesful',
                    actionType: 'Button',
                    action: 'signin',
                    login_cookie: abInline,
                    auto_pop: popupLogin,
                    page:
                        pagePath === 'results'
                            ? 'SRP'
                            : isEmpty(pagePath) || isHiFiveFlow
                            ? 'HP'
                            : pathname.length > 4 && pathname[4] === 'info' && pathname[2] === 'itinerary'
                            ? 'Itinerary'
                            : 'Confirmation_Page',

                    currentPage: pagePath,
                    login_type: 'Email',
                    first_time_login: 'No',
                    keep_me_logged_in: rememberCheckedStatus ? 'Yes' : 'No'
                })
                setUserSignedIn(true)
                // TODO-AB : OTP case
                const { user = {} } = data || {}
                if (pathname.length > 4 && pathname[4] === 'info' && pathname[2] === 'itinerary') {
                    const resp = await getUserProfileData()
                    toggleModalAndClosePage(false)
                } else if (!isEmpty(redirectUrl)) {
                    window.location.href = redirectUrl
                } else {
                    if (
                        (!isEmpty(user.mobile) && !isEmpty(user.countryCode)) ||
                        (user.peopleNudge && user.peopleNudge.mobile === true)
                    ) {
                        setTimeout(() => {
                            window.location.reload()
                        }, 100)
                    } else {
                        setPageName(USER_PROFILE_PAGE_CONTANTS.EMAIL_MOBILE_LINKED)
                    }
                }
                // if(data.showMobile)
                // {
                // }
                //                 else if(data.LinkAccounts)
                //                 {
                // setPageName(USER_PROFILE_PAGE_CONTANTS.LINK_ACCOUNTS)
                //                 }
                // else{
                // setTimeout(() => {
                //     window.location.reload()
                // }, 100)
                // }
                setSignInButtonLoading(false)
            }
        } else {
            ClevertapEvent({
                actionName: 'Invalid_value_entered',
                actionType: 'Button',
                page:
                    pagePath === 'results'
                        ? 'SRP'
                        : isEmpty(pagePath) || isHiFiveFlow
                        ? 'HP'
                        : pathname.length > 4 && pathname[4] === 'info' && pathname[2] === 'itinerary'
                        ? 'Itinerary'
                        : 'Confirmation_Page',

                currentPage: pagePath,
                field_name: 'email',
                form_name: 'EmailLogin'
            })
            setSignInButtonLoading(false)
        }
    }
  
    const SigninBlock = (
        <SignInBlockNew
            animatedClass={animatedClass}
            toggle={handleSignInToggle}
            signInError={signInError}
            validateEmailHandler={validateEmailHandler}
            changeEmailHandler={changeEmailHandler}
            isEmailValid={isEmailValid}
            email={email}
            validatePasswordHandler={validatePasswordHandler}
            changePasswordHandler={changePasswordHandler}
            isPasswordValid={isPasswordValid}
            password={password}
            spanClass={spanClass}
            checkboxClass={checkboxClass}
            rememberCheckedStatus={rememberCheckedStatus}
            setRememberCheckedStatus={setRememberCheckedStatus}
            checkBoxTextClass={checkBoxTextClass}
            onContinue={onContinue}
            isLoading={isSignInButtonLoading}
            errorInfo={errorInfo}
            urlParam={urlParam}
            resultsData={resultsData}
            itineraryData={itineraryData}
            pagePath={pagePath}
            clickHandler={clickHandler}
            handleLinkClick={handleLinkClick}
            setPageName={setPageName}
            signInPasswordType={signInPasswordType}
            setSignInPasswordType={setSignInPasswordType}
            showCloseButton={showCloseButton}
        />
    )

    const SignUpFormBlock = (
        <SignUpForm
            signUpCreate={signUpCreate}
            email={email}
            toggle={handleSignInToggle}
            animatedClass={animatedClass}
            signUpFormError={signUpFormError}
            errorInfo={errorInfo}
            accountExists={accountExists}
            passwordType={passwordType}
            validatePasswordHandler={validatePasswordHandler}
            changePasswordHandler={changePasswordHandler}
            isPasswordValid={isPasswordValid}
            password={password}
            setShowPasswordRules={setShowPasswordRules}
            setPasswordType={setPasswordType}
            showPasswordRules={showPasswordRules}
            spanClass={spanClass}
            lowerCaseRegex={lowerCaseRegex}
            uperCaseRegex={uperCaseRegex}
            oneSpecialCharacterRegex={oneSpecialCharacterRegex}
            numberRegex={numberRegex}
            confirmPasswordType={confirmPasswordType}
            validateConfirmPasswordHandler={validateConfirmPasswordHandler}
            changeConfirmPasswordHandler={changeConfirmPasswordHandler}
            isConfirmPasswordValid={isConfirmPasswordValid}
            confirmPassword={confirmPassword}
            setConfirmPasswordType={setConfirmPasswordType}
            changeFirstNameHandler={changeFirstNameHandler}
            isValidFirstName={isValidFirstName}
            firstName={firstName}
            validateFirstNameHandler={validateFirstNameHandler}
            changeLastNameHandler={changeLastNameHandler}
            isValidLastName={isValidLastName}
            lastName={lastName}
            validateLastNameHandler={validateLastNameHandler}
            toggleGender={toggleGender}
            gender={gender}
            genderError={genderError}
            selectGender={selectGender}
            mobileAndCountryCodeItem={mobileAndCountryCodeItem}
            setShowGSTIN={setShowGSTIN}
            showGSTIN={showGSTIN}
            checkBoxTextClass={checkBoxTextClass}
            handleLinkClick={handleLinkClick}
            gstin={gstin}
            changeGstinHandler={changeGstinHandler}
            isGSTValid={isGSTValid}
            companyName={companyName}
            changeCompanyHandler={changeCompanyHandler}
            isCompanyValid={isCompanyValid}
            travelCheckedStatus={travelCheckedStatus}
            setTravelCheckedStatus={setTravelCheckedStatus}
            ref={errorRef}
            showCloseButton={showCloseButton}
        />
    )
    const MobileSignInUpBlock = (
        <LoginWithMobileNew
            mobileAndCountryCodeItem={mobileAndCountryCodeItem}
            setPageName={setPageName}
            validateMobileHandler={validateMobileHandler}
            isMobileValid={isMobileValid}
            handleLinkClick={handleLinkClick}
            toggle={handleSignInToggle}
            email={email}
            mobile={mobileNumber}
            countryCode={defaultCountryCode}
            setMobileValid={setMobileValid}
            showCloseButton={showCloseButton}
            disableEmailLogin={disableEmailLogin}
            userData={userData}
            superCoinAddNumber={superCoinAddNumber}
            superCoinLogin={superCoinLogin}
            initialRender={initialRender}
            setInitialRender={setInitialRender}
            abLogin={abLogin}
            abInline={abInline}
        />
    )
    const VerifyNumberBlock = (
        <VerifyMobileNumberNew
            toggle={handleSignInToggle}
            mobileNumber={mobileNumber}
            defaultCountryCode={defaultCountryCode}
            setPageName={setPageName}
            checkboxClass={checkboxClass}
            rememberCheckedStatus={rememberCheckedStatus}
            setRememberCheckedStatus={setRememberCheckedStatus}
            checkBoxTextClass={checkBoxTextClass}
            redirectToPage={redirectToPage}
            email={email}
            setMobileNumber={setMobileNumber}
            toggleModalAndClosePage={toggleModalAndClosePage}
            setLinkedEmails={setLinkedEmails}
            setUserSignedIn={setUserSignedIn}
            showCloseButton={showCloseButton}
            setLoginCase={setLoginCase}
            hideLoginBanner={hideLoginBanner}
            superCoinAddNumber={superCoinAddNumber}
            superCoinLogin={superCoinLogin}
            abLogin={abLogin}
            abInline={abInline}
        />
    )
    const VerifyMobileInputFieldBlock = (
        <VerifyMobileInputField
            mobileAndCountryCodeItem={mobileAndCountryCodeItem}
            setPageName={setPageName}
            validateMobileHandler={validateMobileHandler}
            isMobileValid={isMobileValid}
            handleLinkClick={handleLinkClick}
            toggle={handleSignInToggle}
            email={email}
            mobile={mobileNumber}
            countryCode={defaultCountryCode}
            showCloseButton={showCloseButton}
            superCoinAddNumber={superCoinAddNumber}
        />
    )
    const VerifyEmailBlock = (
        <VerifyEmail
            toggle={handleSignInToggle}
            email={email}
            setPageName={setPageName}
            checkboxClass={checkboxClass}
            rememberCheckedStatus={rememberCheckedStatus}
            setRememberCheckedStatus={setRememberCheckedStatus}
            checkBoxTextClass={checkBoxTextClass}
            redirectToPage={redirectToPage}
            toggleModalAndClosePage={toggleModalAndClosePage}
            showCloseButton={showCloseButton}
        />
    )
    const EmailLinked = (
        <EmailsLinked
            toggle={handleSignInToggle}
            mobileNumber={mobileNumber}
            defaultCountryCode={defaultCountryCode}
            email={email}
            linkedEmails={linkedEmails}
            setEmail={setEmail}
            setPageName={setPageName}
            handleLinkClick={handleLinkClick}
            showCloseButton={showCloseButton}
        />
    )
    const LinkAccountsBlock = (
        <LinkAccounts
            handleLinkClick={handleLinkClick}
            toggle={handleSignInToggle}
            setPageName={setPageName}
            email={email}
            toggleModalAndClosePage={toggleModalAndClosePage}
            showCloseButton={showCloseButton}
        />
    )
    const LoaderBlock = <Loader />
    const LinkAccountsSuccessBlock = <LinkAccountsSuccess />

    const PersonalDetailsBlock = (
        <PersonalDetails
            email={email}
            validateEmailHandler={validateEmailHandler}
            changeEmailHandler={changeEmailHandler}
            isEmailValid={isEmailValid}
            travelCheckedStatus={travelCheckedStatus}
            setTravelCheckedStatus={setTravelCheckedStatus}
            changeLastNameHandler={changeLastNameHandler}
            isValidLastName={isValidLastName}
            lastName={lastName}
            validateLastNameHandler={validateLastNameHandler}
            changeFirstNameHandler={changeFirstNameHandler}
            isValidFirstName={isValidFirstName}
            firstName={firstName}
            validateFirstNameHandler={validateFirstNameHandler}
            toggle={handleSignInToggle}
            gender={gender}
            setGender={setGender}
            validateEmail={validateEmail}
            setEmail={setEmail}
            errorInfo={errorInfo}
            toggleModalAndClosePage={toggleModalAndClosePage}
        />
    )
    const EmailLinkedPersonalDetailsBlock = (
        <EmailLinkedPersonalDetails
            email={email}
            validateEmailHandler={validateEmailHandler}
            changeEmailHandler={changeEmailHandler}
            isEmailValid={isEmailValid}
            travelCheckedStatus={travelCheckedStatus}
            setTravelCheckedStatus={setTravelCheckedStatus}
            changeLastNameHandler={changeLastNameHandler}
            isValidLastName={isValidLastName}
            lastName={lastName}
            validateLastNameHandler={validateLastNameHandler}
            changeFirstNameHandler={changeFirstNameHandler}
            isValidFirstName={isValidFirstName}
            firstName={firstName}
            validateFirstNameHandler={validateFirstNameHandler}
            toggle={handleSignInToggle}
            gender={gender}
            setGender={setGender}
            validateEmail={validateEmail}
            setEmail={setEmail}
            errorInfo={errorInfo}
            toggleModalAndClosePage={toggleModalAndClosePage}
        />
    )
    const ResetBlock = (
        <ResetPassword
            toggle={handleSignInToggle}
            validateEmailHandler={validateEmailHandler}
            changeEmailHandler={changeEmailHandler}
            isEmailValid={isEmailValid}
            email={email}
            resetPassword={resetPassword}
            validateEmail={validateEmail}
            showCloseButton={showCloseButton}
        />
    )

    const ResetConfirmationBlock = (
        <CheckYourEmail
            toggle={handleSignInToggle}
            setPageName={setPageName}
            setEmail={setEmail}
            clickHandler={clickHandler}
            email={email}
            resendResetPassword={resendResetPassword}
            showCloseButton={showCloseButton}
        />
    )

    const SignedInUserBlock = (
        <RegisteredUserBlock
            animatedClass={animatedClass}
            toggle={handleSignInToggle}
            email={email}
            validatePasswordHandler={validatePasswordHandler}
            changePasswordHandler={changePasswordHandler}
            isPasswordValid={isPasswordValid}
            password={password}
            spanClass={spanClass}
            checkboxClass={checkboxClass}
            rememberCheckedStatus={rememberCheckedStatus}
            setRememberCheckedStatus={setRememberCheckedStatus}
            checkBoxTextClass={checkBoxTextClass}
            onContinue={onContinue}
            clickHandler={clickHandler}
            handleLinkClick={handleLinkClick}
            goBackAnimation={goBackAnimation}
            showCloseButton={showCloseButton}
        />
    )

    return (
        <Modal isShowing={isShowing} overlayClassName="z-70" overlayStyle={{ zIndex: 10000 }}>
            {renderPage()}
        </Modal>
    )
}

export default ViewContainer
